import { signOut } from 'utils/common-services/cookie.services'

const AccessDenied = () => {
  const handleBackToLogin = () => {
    signOut() // 👈 clear token and cookies
    window.location.href = '/login'
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#f5f5f5'
    }}
    >
      <div style={{
        background: '#fff',
        padding: '48px',
        borderRadius: '12px',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}
      >
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🚫</div>
        <h1 style={{ fontSize: '28px', color: '#111', marginBottom: '8px' }}>
          Access Denied
        </h1>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px' }}>
          Your IP address is not whitelisted to access this application.
        </p>
        <p style={{ fontSize: '14px', color: '#999', marginBottom: '32px' }}>
          Please contact your administrator.
        </p>
        <button
          onClick={handleBackToLogin} // 👈 use new handler
          style={{
            background: '#4F46E5',
            color: '#fff',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Back to Login
        </button>
      </div>
    </div>
  )
}

export default AccessDenied
